<template>
    <div id="terms">
        <termsComponent></termsComponent>
    </div>
</template>

<script>
    import termsComponent from '@/components/cust_components/terms_component.vue';

    export default {
        name: 'TermsAndConditions',
        data() {
            return {
            }
        },
        components: {
            termsComponent
        }
    }
</script>